import {Component, Injector, signal} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {RatingItemIconSet} from "@models";
import {IconDefinitions} from "../../../../web-manager/subModules/assessments/pages/rating-item-icon-sets-page/rating-item-icon-sets-page.component";

export interface DialogData_RatingItemIconSetConfigurationDialogInput extends MatDialogDataBaseInput {
	ratingItemIconSet: RatingItemIconSet;
}

export interface DialogData_RatingItemIconSetConfigurationDialogOutput extends MatDialogDataBaseOutput {
	ratingItemIconSet: RatingItemIconSet;
}

@Component({
	selector: "sim-rating-item-icon-set-configuration-dialog",
	standalone: false,
	templateUrl: "./rating-item-icon-set-configuration-dialog.component.html",
	styleUrl: "./rating-item-icon-set-configuration-dialog.component.scss",
})
export class RatingItemIconSetConfigurationDialogComponent extends BasicMaterialDialog<
	RatingItemIconSetConfigurationDialogComponent,
	DialogData_RatingItemIconSetConfigurationDialogInput,
	DialogData_RatingItemIconSetConfigurationDialogOutput
> {
	protected readonly ratingItemIconSet = signal<RatingItemIconSet>(this.data.ratingItemIconSet);

	constructor(injector: Injector) {
		super(injector);
	}

	protected setIconDefinitions(iconDefinitions: IconDefinitions): void {
		this.ratingItemIconSet.update((iconSet) => {
			return {
				...iconSet,
				icons: iconDefinitions,
			};
		});
	}

	public ok(): void {
		this.close({
			action: "ok",
			ratingItemIconSet: this.ratingItemIconSet(),
		});
	}
}
